import React from 'react'
import styles from './style/visit_lite_section_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import Foundation from '../../design-system/foundations/Foundation'
import Button from '../../design-system/basics/button/Button'
import Translation from '../../global/Translation'
import { withRouter } from 'react-router-dom'

const VisitLite = (props) => {

    return (
        <div className={styles['visit-lite']}>
            <Foundation back-accent-100>
                <div className={styles['visit-lite-text-container']}>
                    <Typography className={styles['visit-lite-title']} typeface="title-l-regular">
                        <Translation id="want_to_see_new_arrivals" defaultMessage="Want to see these new arrivals up close?"/>
                    </Typography>

                    <div className={styles['visit-lite-button']}>
                        <Button style-black
                                size-l
                                onClick={() => window.open(props.url)}
                                img="arrow_short"
                                hImg="arrow_large"
                                gtmLabel="item-list_button_go-to-book-online-visit"
                        >
                            <Translation id="book_online_visit"
                                         defaultMessage="Book online visit"
                            />
                        </Button>
                    </div>
                </div>
            </Foundation>
        </div>
    )
};

export default withRouter(VisitLite);